import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import '../../css/huerto/scoringTable.css';
import '../../css/huerto/scoring.css';
import ContractsService from '../../../services/ContractsService';
import Globals from '../../../Globals';
import FunctionGeneral from '../scoring/functionsGeneral';
import Loading from '../../bronson/Loading';
import ModalfiltrosAsignacionVV from './modalfiltrosAsignacionVV';

const AsignacionVolumenVendedor = props => {
    const [
        metricaAsignacionVolumenVendedor,
        setmetricaAsignacionVolumenVendedor,
    ] = useState(props.metricaAsignacionVolumenVendedor);
    const [maxPag, setMaxPag] = useState(0);
    const [li_Pag, setli_Pag] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setrowsPerPage] = useState(15);
    const [rows, setrows] = useState([]);
    const [codigofilter, setcodigofilter] = useState('');
    const [nombrefiter, setnombrefiter] = useState('');
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    const [dataConcesionario, setdataConcesionario] = useState([]);
    const [detalle, setdetalle] = useState(false);
    const [loaded, setloaded] = useState(false);
    const [modalfiltrosAsignacionVV, setModalfiltrosAsignacionVV] =
        useState(false);

    useEffect(() => {
        var rowstable = [];
        var row = [];
        if (!detalle) {
            setdataConcesionario([]);
            metricaAsignacionVolumenVendedor.forEach(element => {
                if (row.length === 0) row.push(element);
                else if (row[0].POCIDCANALVWF === element.POCIDCANALVWF)
                    row.push(element);
                else {
                    let rowTable = [];
                    rowTable.CONCECIONNOMBRE = row[0].CONCECIONNOMBRE;
                    rowTable.POCIDCANALVWF = row[0].POCIDCANALVWF;
                    rowTable.PREASIGNADO = 0;
                    rowTable.NOPREASIGNADO = 0;
                    rowTable.HUERFANO = 0;
                    rowTable.AUTOASIGNADO = 0;
                    row.forEach(elementRow => {
                        if (elementRow.PREASIGNADO === 'S')
                            rowTable.PREASIGNADO = elementRow.TOTALCONTRATOS;
                        else if (elementRow.PREASIGNADO === 'N')
                            rowTable.NOPREASIGNADO = elementRow.TOTALCONTRATOS;
                        else if (elementRow.PREASIGNADO === 'A')
                            rowTable.AUTOASIGNADO = elementRow.TOTALCONTRATOS;
                        else rowTable.HUERFANO = elementRow.TOTALCONTRATOS;
                    });
                    rowstable.push(rowTable);
                    row = [];
                    row.push(element);
                }
            });
            if (row.length > 0) {
                let rowTable = [];
                rowTable.CONCECIONNOMBRE = row[0].CONCECIONNOMBRE;
                rowTable.POCIDCANALVWF = row[0].POCIDCANALVWF;
                rowTable.PREASIGNADO = 0;
                rowTable.NOPREASIGNADO = 0;
                rowTable.HUERFANO = 0;
                rowTable.AUTOASIGNADO = 0;
                row.forEach(elementRow => {
                    if (elementRow.PREASIGNADO === 'S')
                        rowTable.PREASIGNADO = elementRow.TOTALCONTRATOS;
                    else if (elementRow.PREASIGNADO === 'N')
                        rowTable.NOPREASIGNADO = elementRow.TOTALCONTRATOS;
                    else if (elementRow.PREASIGNADO === 'A')
                        rowTable.AUTOASIGNADO = elementRow.TOTALCONTRATOS;
                    else rowTable.HUERFANO = elementRow.TOTALCONTRATOS;
                });
                rowstable.push(rowTable);
            }
        }
        setrows(rowstable);
    }, [metricaAsignacionVolumenVendedor, detalle]);

    useEffect(() => {
        var rowstable = [];
        var row = [];
        if (dataConcesionario.length === 0) setdetalle(false);
        else {
            dataConcesionario.forEach(element => {
                if (row.length === 0) row.push(element);
                else if (
                    row[0].IDVENDEDORASIGNADO === element.IDVENDEDORASIGNADO
                )
                    row.push(element);
                else {
                    let rowTable = [];
                    rowTable.CONCECIONNOMBRE =
                        row[0].VENDEDORASIGNADO !== null
                            ? new FunctionGeneral().capitalizeText(
                                  row[0].VENDEDORASIGNADO.split(' ')
                              )
                            : '';
                    rowTable.POCIDCANALVWF = row[0].IDVENDEDORASIGNADO;
                    rowTable.PREASIGNADO = 0;
                    rowTable.NOPREASIGNADO = 0;
                    rowTable.HUERFANO = 0;
                    rowTable.AUTOASIGNADO = 0;
                    row.forEach(elementRow => {
                        if (elementRow.PREASIGNADO === 'S')
                            rowTable.PREASIGNADO = elementRow.TOTALCONTRATOS;
                        else if (elementRow.PREASIGNADO === 'N')
                            rowTable.NOPREASIGNADO = elementRow.TOTALCONTRATOS;
                        else if (elementRow.PREASIGNADO === 'A')
                            rowTable.AUTOASIGNADO = elementRow.TOTALCONTRATOS;
                        else rowTable.HUERFANO = elementRow.TOTALCONTRATOS;
                    });
                    rowstable.push(rowTable);
                    row = [];
                    row.push(element);
                }
            });
            if (row.length > 0) {
                let rowTable = [];
                rowTable.CONCECIONNOMBRE = row[0].VENDEDORASIGNADO;
                rowTable.POCIDCANALVWF = row[0].IDVENDEDORASIGNADO;
                rowTable.PREASIGNADO = 0;
                rowTable.NOPREASIGNADO = 0;
                rowTable.HUERFANO = 0;
                rowTable.AUTOASIGNADO = 0;
                row.forEach(elementRow => {
                    if (elementRow.PREASIGNADO === 'S')
                        rowTable.PREASIGNADO = elementRow.TOTALCONTRATOS;
                    else if (elementRow.PREASIGNADO === 'N')
                        rowTable.NOPREASIGNADO = elementRow.TOTALCONTRATOS;
                    else if (elementRow.PREASIGNADO === 'A')
                        rowTable.AUTOASIGNADO = elementRow.TOTALCONTRATOS;
                    else rowTable.HUERFANO = elementRow.TOTALCONTRATOS;
                });
                rowstable.push(rowTable);
            }

            setrows(rowstable);
        }
    }, [dataConcesionario]);

    useEffect(() => {
        setMaxPag(
            parseInt(rows.length / rowsPerPage) +
                (rows.length % rowsPerPage === 0 ? -1 : 0)
        );
    }, [rows, rowsPerPage]);

    useEffect(() => {
        var new_li = [];
        var positioncalco = 0;
        if (page === 1) positioncalco = 1;
        else if (page === 0) positioncalco = 0;
        else if (page === maxPag) positioncalco = 4;
        else if (page + 1 === maxPag) positioncalco = 3;
        else if (page >= 2) positioncalco = 2;

        for (
            let i = page - positioncalco;
            new_li.length < 5 && page - positioncalco + new_li.length <= maxPag;
            i++
        ) {
            if (i >= 0) {
                if (i === page)
                    new_li.push(
                        <li className="c-pagination__item" key={'item_' + i}>
                            <span
                                aria-current="page"
                                className="c-pagination__link  is-active"
                                onClick={() => handleChangePage(i)}
                            >
                                {i + 1}
                            </span>
                        </li>
                    );
                else
                    new_li.push(
                        <li className="c-pagination__item" key={'item_' + i}>
                            <span
                                aria-current="page"
                                className="c-pagination__link"
                                onClick={() => handleChangePage(i)}
                            >
                                {i + 1}
                            </span>
                        </li>
                    );
            } else new_li.push(<span key="-----"></span>);
        }
        setli_Pag(new_li);
    }, [page, maxPag, rows]);

    useEffect(() => {
        setPage(0);
        var rowstable = [];
        if (codigofilter !== '') {
            props.metricaAsignacionVolumenVendedor.forEach(element => {
                if (codigofilter.length <= element.POCIDCANALVWF.length) {
                    if (
                        element.POCIDCANALVWF.toUpperCase().match(
                            codigofilter.toUpperCase()
                        )
                    )
                        rowstable.push(element);
                }
            });
            setmetricaAsignacionVolumenVendedor(rowstable);
        } else if (nombrefiter !== '') {
            props.metricaAsignacionVolumenVendedor.forEach(element => {
                if (nombrefiter.length <= element.CONCECIONNOMBRE.length)
                    if (
                        element.CONCECIONNOMBRE.toUpperCase().match(
                            nombrefiter.toUpperCase()
                        )
                    )
                        rowstable.push(element);
            });
            setmetricaAsignacionVolumenVendedor(rowstable);
        } else
            setmetricaAsignacionVolumenVendedor(
                props.metricaAsignacionVolumenVendedor
            );
    }, [codigofilter, nombrefiter]);

    useEffect(() => {
        if (fechaDesde === '' && fechaHasta === '') {
            setPage(0);
            var rowstable = [];
            if (codigofilter !== '') {
                props.metricaAsignacionVolumenVendedor.forEach(element => {
                    if (codigofilter.length <= element.POCIDCANALVWF.length) {
                        if (
                            element.POCIDCANALVWF.toUpperCase().match(
                                codigofilter.toUpperCase()
                            )
                        )
                            rowstable.push(element);
                    }
                });
                setmetricaAsignacionVolumenVendedor(rowstable);
            } else if (nombrefiter !== '') {
                props.metricaAsignacionVolumenVendedor.forEach(element => {
                    if (nombrefiter.length <= element.CONCECIONNOMBRE.length)
                        if (
                            element.CONCECIONNOMBRE.toUpperCase().match(
                                nombrefiter.toUpperCase()
                            )
                        )
                            rowstable.push(element);
                });
                setmetricaAsignacionVolumenVendedor(rowstable);
            } else
                setmetricaAsignacionVolumenVendedor(
                    props.metricaAsignacionVolumenVendedor
                );
        } else {
            getAsignacionVolumenVendedorToMetricas();
        }
    }, [fechaDesde, fechaHasta]);

    async function getAsignacionVolumenVendedorToMetricas() {
        setmetricaAsignacionVolumenVendedor([]);
        setloaded(true);
        var _response =
            await new ContractsService().getAsignacionVolumenVendedorToMetricas(
                props.cookies.get(Globals.COOKIES.JWT).AccessToken,
                fechaDesde,
                fechaHasta
            );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setmetricaAsignacionVolumenVendedor(response);
            setloaded(false);
        }
    }
    const handleChangePage = newPage => {
        if (newPage >= 0 && newPage <= maxPag) setPage(newPage);
    };
    const handleChangeRowsPerPage = event => {
        setrowsPerPage(+event.target.value);
        setPage(0);
    };

    function detalleConcesionario(params) {
        ReadAsignacionVolumenVendedorToMetricasToConcesionarios(params);
    }

    async function ReadAsignacionVolumenVendedorToMetricasToConcesionarios(
        DealerCodeVWFS
    ) {
        setloaded(true);
        setdetalle(true);
        var _response =
            await new ContractsService().ReadAsignacionVolumenVendedorToMetricasToConcesionarios(
                props.cookies.get(Globals.COOKIES.JWT).AccessToken,
                DealerCodeVWFS
            );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setdataConcesionario(response);
        }
        setloaded(!true);
    }

    const displayTableConcesionariosGeneral = () => {
        if (dataConcesionario.length === 0)
            return (
                <div className="u-1/1 c-table-wrapper c-table--wide tablaVencimientos">
                    <Loading ariaBusy={loaded}></Loading>
                    <table>
                        <thead>
                            <tr>
                                <th scope="col">Codigo Concesionario</th>
                                <th scope="col" style={{ minWidth: '400px' }}>
                                    Nombre Concesionario
                                </th>
                                <th scope="col">Pre Asignados</th>
                                <th scope="col">Asignados JJVV</th>
                                <th scope="col">Auto Asignado</th>
                                <th scope="col">No asignados</th>
                                <th scope="col">Contrts Totales</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map(rowTable => (
                                    <tr
                                        id={rowTable.POCIDCANALVWF}
                                        key={
                                            rowTable.POCIDCANALVWF +
                                            rowTable.CONCECIONNOMBRE
                                        }
                                        onClick={() =>
                                            detalleConcesionario(
                                                rowTable.POCIDCANALVWF
                                            )
                                        }
                                    >
                                        <th>{rowTable.POCIDCANALVWF}</th>
                                        <td>{rowTable.CONCECIONNOMBRE}</td>
                                        <td>{rowTable.PREASIGNADO}</td>
                                        <td>{rowTable.NOPREASIGNADO}</td>
                                        <td>{rowTable.AUTOASIGNADO}</td>
                                        <td>{rowTable.HUERFANO}</td>
                                        <td>
                                            {rowTable.HUERFANO +
                                                rowTable.NOPREASIGNADO +
                                                rowTable.PREASIGNADO +
                                                rowTable.AUTOASIGNADO}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            );
        else return <div></div>;
    };
    const displayTableConcesionariosDetalle = () => {
        return (
            <div className="u-1/1 c-table-wrapper c-table--wide tablaVencimientos">
                <table>
                    <thead>
                        <tr>
                            <th scope="col">Vendedor Asig</th>
                            <th scope="col" style={{ minWidth: '300px' }}>
                                ID Vendedor Asignado
                            </th>
                            <th scope="col">Pre Asignados</th>
                            <th scope="col">Asignados JJVV</th>
                            <th scope="col">AutoAsignados V</th>
                            <th scope="col">No asignados</th>
                            <th scope="col">Contrts Totales</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map(rowTable => (
                                <tr
                                    id={rowTable.POCIDCANALVWF}
                                    key={rowTable.POCIDCANALVWF}
                                >
                                    <th>{rowTable.POCIDCANALVWF}</th>
                                    <td>{rowTable.CONCECIONNOMBRE}</td>
                                    <td>{rowTable.PREASIGNADO}</td>
                                    <td>{rowTable.NOPREASIGNADO}</td>
                                    <td>{rowTable.AUTOASIGNADO}</td>
                                    <td>{rowTable.HUERFANO}</td>
                                    <td>
                                        {rowTable.HUERFANO +
                                            rowTable.NOPREASIGNADO +
                                            rowTable.PREASIGNADO +
                                            rowTable.AUTOASIGNADO}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        );
    };
    const pagination = () => {
        return (
            <section className="u-1/1">
                <div className="o-layout__item u-9/12 u-12/12@s">
                    <nav
                        className="c-pagination tablaVencimientos"
                        aria-label="Pagination"
                    >
                        <ul className="c-pagination__list">
                            <li className="c-pagination__item">
                                <a
                                    onClick={() => handleChangePage(page - 1)}
                                    className={
                                        (props.page > 0 ? '' : 'is-disabled') +
                                        ' c-pagination__link  c-pagination__link--stepper-prev'
                                    }
                                    style={{
                                        display: 'flex',
                                        position: 'inherit',
                                    }}
                                    title="prev page"
                                ></a>
                            </li>
                            {li_Pag}
                            <li className="c-pagination__item">
                                <a
                                    onClick={() => handleChangePage(page + 1)}
                                    className={
                                        (page + 1 <= maxPag
                                            ? ''
                                            : 'is-disabled') +
                                        'c-pagination__link  c-pagination__link--stepper-next'
                                    }
                                    style={{ display: 'flex' }}
                                    title="next page"
                                >
                                    <span className="u-visually-hidden">
                                        next page
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div
                    className="o-layout__item u-3/12 u-12/12@s c-form-field__box u-text-right"
                    style={{ marginTop: '16px' }}
                >
                    <span
                        style={{ verticalAlign: 'middle', marginRight: '10px' }}
                        className="u-text-brand"
                    >
                        Concesionario por página
                    </span>
                    <div
                        className="c-input c-input--select"
                        style={{ width: 'fit-content', float: 'right' }}
                    >
                        <select
                            className="c-input__input"
                            onChange={handleChangeRowsPerPage}
                            defaultValue={rowsPerPage}
                        >
                            <option>15</option>
                            <option>30</option>
                            <option>50</option>
                            <option>100</option>
                            <option>1000</option>
                        </select>
                    </div>
                </div>
            </section>
        );
    };
    const displayConcesionariosGeneral = () => {
        return (
            <div className="u-pb-small u-rema-full-height">
                <section className="o-content-section o-page-wrap o-page-wrap--xsmall">
                    <div className="o-component-wrapper u-hide@s">
                        <span
                            className="back-to-matrix u-float-left"
                            onClick={() =>
                                props.setviewAsignacionVolumenVendedor(false)
                            }
                        >
                            <i className="c-icon c-icon--[semantic-back] c-icon--small" />
                            <label className="iconHover">
                                Volver a metricas
                            </label>
                        </span>
                        <h3 className="u-text-center">
                            <div
                                className="iconHover"
                                style={{ display: 'contents' }}
                                onClick={() =>
                                    props.setviewAsignacionVolumenVendedor(
                                        false
                                    )
                                }
                            >
                                Metricas Asignación de volumen a Vendedor
                            </div>
                        </h3>
                    </div>
                    <section className="o-layout__item u-1/1">
                        <div className="o-layout__item u-1/2">
                            <button
                                className="c-btn o-layout__item u-1/3"
                                style={{ marginTop: '20px' }}
                                onClick={() =>
                                    props.tableCreate(rows, 'metricaAsignacion')
                                }
                            >
                                Descargar metrica - Asignacion volumen vendedor
                            </button>
                        </div>

                        <div className="o-layout__item u-1/2">
                            <div className="input-div u-float-right">
                                <button
                                    className="c-btn c-btn--secondary"
                                    onClick={() =>
                                        setModalfiltrosAsignacionVV(true)
                                    }
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16.5 21"
                                    >
                                        <path
                                            id="Shape"
                                            d="M5.25,1.5h1.5V12H5.25Zm0,18h1.5v3H5.25ZM6,18a2.25,2.25,0,1,1,2.25-2.25A2.25,2.25,0,0,1,6,18Zm0-3a.75.75,0,1,0,.75.75A.75.75,0,0,0,6,15ZM17.25,1.5h1.5V12h-1.5Zm0,18h1.5v3h-1.5ZM18,18a2.25,2.25,0,1,1,2.25-2.25A2.307,2.307,0,0,1,18,18Zm0-3a.75.75,0,1,0,.75.75A.709.709,0,0,0,18,15Zm-6.75-3h1.5V22.5h-1.5Zm0-10.5h1.5v3h-1.5Zm.75,9A2.307,2.307,0,0,1,9.75,8.25a2.25,2.25,0,0,1,4.5,0A2.307,2.307,0,0,1,12,10.5Zm0-3a.709.709,0,0,0-.75.75.75.75,0,0,0,1.5,0A.709.709,0,0,0,12,7.5Z"
                                            transform="translate(-3.75 -1.5)"
                                            fill="#004666"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                    FILTROS
                                </button>
                            </div>
                        </div>
                        {modalfiltrosAsignacionVV && (
                            <ModalfiltrosAsignacionVV
                                setModalfiltrosAsignacionVV={
                                    setModalfiltrosAsignacionVV
                                }
                                onchangeNombre={setnombrefiter}
                                onchangeCodigo={setcodigofilter}
                                setFechaDesde={setFechaDesde}
                                setFechaHasta={setFechaHasta}
                            />
                        )}
                    </section>
                    <section className="o-layout__item u-1/1">
                        {displayTableConcesionariosGeneral()}
                        {pagination()}
                    </section>
                </section>
            </div>
        );
    };
    const displayConcesionarioDetalle = () => {
        var CONCECIONNOMBRE = '';
        var POCIDCANALVWF = '';
        if (dataConcesionario.length > 0) {
            CONCECIONNOMBRE = dataConcesionario[0].CONCECIONNOMBRE;
            POCIDCANALVWF = dataConcesionario[0].POCIDCANALVWF;
        }
        return (
            <div className="u-pb-small u-rema-full-height">
                <Loading ariaBusy={loaded}></Loading>
                <section className="o-content-section o-page-wrap o-page-wrap--xsmall">
                    <div className="o-component-wrapper u-hide@s">
                        <span
                            className="back-to-matrix u-float-left"
                            onClick={() => setdetalle(false)}
                        >
                            <i className="c-icon c-icon--[semantic-back] c-icon--small" />
                            <label className="iconHover">Volver</label>
                        </span>
                        <h3 className="u-text-center">
                            <div
                                className="iconHover"
                                style={{ display: 'contents' }}
                                onClick={() => setdetalle(false)}
                            >
                                Metricas Asignación JJVV ({CONCECIONNOMBRE}{' '}
                                {POCIDCANALVWF})
                            </div>
                        </h3>
                    </div>
                    <section className="o-layout__item u-1/1">
                        {displayTableConcesionariosDetalle()}
                        {pagination()}
                    </section>
                </section>
            </div>
        );
    };
    return (
        <React.Fragment>
            <div>
                {!detalle && <div> {displayConcesionariosGeneral()}</div>}
                {detalle && <div>{displayConcesionarioDetalle()}</div>}
            </div>
        </React.Fragment>
    );
};

export default withCookies(withRouter(AsignacionVolumenVendedor));
